export default "/images/16eb41b4331bcc494673eea53f200ce6.avif";